import React from 'react';
import BackNav from './BackNav';
import { STUDY_HUB } from '../../config/appLabels';

/** Back link to the signed-in overview (Study hub). */
export default function StudyHubBackNav() {
  return <BackNav to={STUDY_HUB.path} label={STUDY_HUB.name} />;
}
